export default __webpack_public_path__ + "static/media/AU.0b002403.svg";